module.exports = __webpack_public_path__ + "static/media/waveform.f9519c04.svg";